"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_2769qdh2hj() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ThreeSixty.tsx";
  var hash = "7b87893ad04394f901069a744edb0071cb2c10a0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ThreeSixty.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 43
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7b87893ad04394f901069a744edb0071cb2c10a0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2769qdh2hj = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2769qdh2hj();
var Icon = (cov_2769qdh2hj().s[0]++, {
  name: '360',
  svg: "<path d=\"M4.50342 10.4875C4.50342 9.55867 5.10925 8.52867 6.48752 7.66725C7.84817 6.81684 9.80568 6.25 12.0334 6.25C14.2612 6.25 16.2187 6.81684 17.5793 7.66725C18.9576 8.52867 19.5634 9.55867 19.5634 10.4875C19.5634 11.5282 18.7909 12.7073 17.056 13.6055C16.4429 13.9229 16.2032 14.6772 16.5206 15.2902C16.838 15.9033 17.5923 16.143 18.2054 15.8256C20.3589 14.7107 22.0634 12.8491 22.0634 10.4875C22.0634 8.38566 20.7038 6.67192 18.9043 5.54725C17.0872 4.41158 14.6547 3.75 12.0334 3.75C9.41209 3.75 6.9796 4.41158 5.16252 5.54725C3.36306 6.67192 2.00342 8.38566 2.00342 10.4875C2.00342 12.5893 3.36306 14.3031 5.16252 15.4277C6.87736 16.4995 9.14028 17.149 11.5928 17.2187L9.69391 19.1176C9.20575 19.6058 9.20575 20.3972 9.69391 20.8854C10.1821 21.3735 10.9735 21.3735 11.4617 20.8854L15.1123 17.2348C15.8943 16.4527 15.8943 15.1848 15.1123 14.4027L11.4617 10.7521C10.9735 10.264 10.1821 10.264 9.69391 10.7521C9.20575 11.2403 9.20575 12.0317 9.69391 12.5199L11.8983 14.7243C9.72659 14.7019 7.8206 14.1409 6.48752 13.3077C5.10925 12.4463 4.50342 11.4163 4.50342 10.4875Z\" fill=\"currentColor\"/>"
});
var _default = exports["default"] = Icon;